const moveRoutes = {
  index: {
    path: 'index.maneuver.move',
    url: '/mouvement',
  },
  selectWagons: {
    path: 'index.maneuver.move.wagon',
    url: '/selection-wagons',
  },
  selectRailway: {
    path: 'index.maneuver.move.selectRailway',
    url: '/selection-voie',
  },
  report: {
    path: 'index.maneuver.move.report',
    url: '/rapport',
  },
}

export default moveRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/move/routes.js